/**
 * Jquery
 */
import $ from "jquery";

/**
 * Vimeo
 */
import Player from "@vimeo/player";

export default class BannerVideoHandler {
    // Elements
    videoElement        = document.querySelector('[data-id="banner-video"]');
    videoPlayElement    = $('[data-id="banner-video-play"]');
    videoPauseElement    = $('[data-id="banner-video-pause"]');

    // Setup media player
    player              = ($(this.videoElement).length > 0) ? new Player(this.videoElement) : '';

    // Flags
    videoLoop           = 0;
    videoState          = "paused";
    buttonFadeSpeed     = 100;

    constructor() {
        if($(this.videoElement).length > 0) {

            // Add cue points
            this.AddCuePoints();

            // Listeners
            this.ListenToClickOnPlayElement();
            this.ListenToClickOnPauseElement();
            this.ListenToCuePointsVideo();
        }
    }

    // Add cue points to hook into for auto pause after loop
    AddCuePoints() {
        // Add cue point at start of video
        this.player.addCuePoint(0, {
           customKey: 'start'
        }).then(function(id){

        }).catch(function(error) {
            switch (error.name) {
                case 'UnsupportedError':
                    // cue points are not supported with the current player or browser
                    break;

                case 'RangeError':
                    // the time was less than 0 or greater than the video’s duration
                    break;

                default:
                    // some other error occurred
                    break;
            }
        });

        // Add cue point at end of video
        this.player.getDuration().then((duration) => {
            // Add cue point at end of video - 0.25 seconds to ensure the if statement can be executed at start of video
            this.player.addCuePoint(duration - 0.25, {
                customKey: 'end'
            }).then(function(id){
            }).catch(function(error) {
                switch (error.name) {
                    case 'UnsupportedError':
                        // cue points are not supported with the current player or browser
                        break;

                    case 'RangeError':
                        // the time was less than 0 or greater than the video’s duration
                        break;

                    default:
                        // some other error occurred
                        break;
                }
            });
        }).catch(function(error) {
            // Error
        });
    }

    // Listen to click on play element
    ListenToClickOnPlayElement() {
        this.videoPlayElement.on("click", () => {
            this.ChangeVideoState();
        });
    }

    // Listen to click on pause element
    ListenToClickOnPauseElement() {
        this.videoPauseElement.on("click", () => {
            this.ChangeVideoState();
        })
    }

    // Listen to cue points of the video
    ListenToCuePointsVideo() {
        // On reaching cue point in video do *
        this.player.on('cuepoint', (cuepoint) => {
            // Check which cue point is reached
            if(cuepoint.data.customKey === 'start') {
                // If video looped pause video on start video
                if(this.videoLoop > 0) {
                    this.ChangeVideoState();
                }
            } else if (cuepoint.data.customKey === "end") {
                // Increase the loop value on end of video
                this.videoLoop++;
            }
        });
    }

    // Change the video state from pause to playing or reversed
    ChangeVideoState() {
        if(this.videoState === "paused") {
            // Set video state to playing
            this.videoState = "playing";

            // Disable paused state to show the play button
            this.DisablePausedState();

            // Play the video
            this.PlayVideo();
        } else if (this.videoState === "playing") {
            // Set video state to paused
            this.videoState = "paused";

            // Disable play state to show the pause button
            this.DisablePlayingState();

            // Pause the video
            this.PauseVideo();
        }
    }

    // Disable paused state to show the play button
    DisablePausedState() {
        // Fade out the Play button
        this.videoPlayElement.fadeOut(this.buttonFadeSpeed, () => {
            // Display the pause button.
            // css().hide() is to ensure the button is displayed as display flex
            this.videoPauseElement.css("display", "flex").hide().fadeIn(this.buttonFadeSpeed);
        })
    }

    // Disable play state to show the pause button
    DisablePlayingState() {
        // Fade out the Pause button
        this.videoPauseElement.fadeOut(this.buttonFadeSpeed, () => {
            // Display the play button.
            // css().hide() is to ensure the button is displayed as display flex
            this.videoPlayElement.css("display", "flex").hide().fadeIn(this.buttonFadeSpeed);
        })
    }

    // Play video
    PlayVideo() {
        this.player.play();
    }

    // Pause video
    PauseVideo() {
        this.player.pause();
    }
}